import GenericModal from "../../../../components/Modals/genericModal";
import { DistributionContext, WebEditorContext } from "../../../../contexts";
import { useContext, useEffect, useState } from "react";
import * as Constants from "../../../../utils/constants"
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";

export default function DistributionDialog() {
    const { distributeDocument, distributionDialogOpen, setDistributionDialogOpen, distributionOptions } = useContext(DistributionContext);
    const { unlockEditor } = useContext(WebEditorContext);
    const [distribution, setDistribution] = useState(Constants.distribution.notSet);
    const [distributionAlternative, setDistributionAlternative] = useState();
    const { t: te } = useTranslation([resources.edit]);
    const { t: tc } = useTranslation([resources.common]);

    useEffect(() => {
        let distributionOption = distributionOptions.find(x => x.selected);
        if (distributionOption) {
            setDistribution(distributionOption.value);
            setDistributionAlternative(distributionOption.distributionAlternative);
        }
    }, [distributionOptions])

    const handleConfirm = () => {
        setDistributionDialogOpen(false);
        distributeDocument(distribution, distributionAlternative);
    }

    const getOptionId = (value) => {
        return `distributionOption-${value}`;
    }

    return (
        <GenericModal
            open={distributionDialogOpen}
            setOpen={(value) => {
                setDistributionDialogOpen(value)
                if (!value) {
                    unlockEditor();
                }
            }}
            onConfirm={handleConfirm}
            onCancel={() => {
                unlockEditor();
                setDistributionDialogOpen(false);
            }}
            confirmButtonText={tc(translations.common.ok)}
            cancelButtonText={tc(translations.common.cancel)}
            showCancelButton={true}
            title={te(translations.edit.distribution.distribution)} >
            <div className="tw-w-full tw-py-4">
                {distributionOptions.map(option => (
                    <div key={option.value} className="tw-bg-white tw-relative tw-px-3 tw-pt-2 tw-pb-0.5 tw-my-1 tw-flex">
                        <div className="tw-flex tw-items-center tw-h-5">
                            <input
                                type="radio"
                                name="distributionOptions"
                                id={getOptionId(option.value)}
                                className="focus:tw-ring-indigo-700 tw-h-4 tw-w-4 tw-text-indigo-700 tw-cursor-pointer tw-border-gray-300"
                                checked={option.value === distribution}
                                onChange={() => {
                                    setDistribution(option.value)
                                    setDistributionAlternative(option.distributionAlternative);
                                }}
                            />
                        </div>
                        <div className="tw-ml-3 tw-flex tw-flex-col tw-cursor-pointer tw-text-sm tw-overflow-x-hidden tw-break-words">
                            <label htmlFor={getOptionId(option.value)} className="tw-font-medium tw-text-left">
                                {option.name}
                            </label>
                            {option.description && <p className="tw-text-gray-500">{option.description}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </GenericModal>
    )
}